@if (enabled) {
  <div class="oapopover-container">
    <span class="featureless" [ngbPopover]="content" triggers="click" [popoverTitle]="title" placement="auto">
      <i class="fa fa-info-circle info-action-icon" aria-hidden="true"></i>
    </span>
  </div>
}
